import React, { useEffect, useState } from "react";
import SelectedDatasetElement from "../SelectedDatasetElement";
import { Axis, AxisAssignedArrays, Dataset, DatasetAxis } from "../types";
import "./styles.css";

const MultiDragArea = ({
  selectedDatasetsArr,
  removeDataset,
  enableXAxis,
  showAxisSelection,
  assignToMultiAxis,
}: {
  selectedDatasetsArr: Array<Dataset>;
  removeDataset: any;
  enableXAxis: boolean;
  showAxisSelection: boolean;
  assignToMultiAxis: any;
}) => {
  const [datasetsWithMultiAxis, setDatasetsWithMultiAxis] = useState<Array<DatasetAxis>>([]);
  const [multiAxisArray, setMultiAxisArray] = useState<AxisAssignedArrays>({ none: [], X: [], Y: [], size: [], color: [] });
  const [fieldXClassName, setFieldXClassName] = useState<string>("empty");
  const [fieldYClassName, setFieldYClassName] = useState<string>("empty");
  const [fieldColorClassName, setFieldColorClassName] = useState<string>("empty");
  const [fieldSizeClassName, setFieldSizeClassName] = useState<string>("empty");

  const onDragStart = (e: any, id: string) => {
    e.dataTransfer.setData("id", id);
  };

  const onDragOver = (e: any) => {
    e.preventDefault();
  };

  // IF X ASSIGNED SWITCH TO UNASSIGNED OR Y AND ASSIGN ONLY ONE NEW X DATASET.
  const onDropMulti = (e: any, axis: Axis) => {
    let id = e.dataTransfer.getData("id");
    let dts = datasetsWithMultiAxis.map((dt) => {
      if (dt.identifier === id) {
        dt.axis = axis;
      }
      return dt;
    });
    setDatasetsWithMultiAxis(dts);
    //if x, y, color or size has assigned dataset, we need to drop it to none and change with new one
    //if not assigned - drop it from current to new
    //switch datasets on drop, just 1 dataset per axis
  };

  const onDropWithSwitch = (e: any, targetAxis: Axis) => {
    let id = e.dataTransfer.getData("id");

    let dts = datasetsWithMultiAxis.map((dt, index) => {
      if (dt.identifier === id && targetAxis == "none") {
        dt.axis = targetAxis;
      } else {
        //switch current with target
        if (dt.identifier === id) {
          const currentAxis = dt.axis;
          const dtTargetAxisIndex = datasetsWithMultiAxis.findIndex((dta) => dta.axis === targetAxis);
          dt.axis = targetAxis;
          datasetsWithMultiAxis[dtTargetAxisIndex].axis = currentAxis;
        }
      }
      return dt;
    });
    setDatasetsWithMultiAxis(dts);
  };

  useEffect(() => {
    //on default assigned first 4, others to "none"
    //when added new dataset it assigned to default axis
    const updateDatasetsArray = (defaultAxis: Axis) => {
      const updatedArray: Array<DatasetAxis> = selectedDatasetsArr.reduce((res: Array<DatasetAxis>, curr, index) => {
        switch (index) {
          case 0:
            res.push({ ...curr, axis: "X" });
            break;
          case 1:
            res.push({ ...curr, axis: "Y" });
            break;
          case 2:
            res.push({ ...curr, axis: "color" });
            break;
          case 3:
            res.push({ ...curr, axis: "size" });
            break;
          default:
            res.push({ ...curr, axis: defaultAxis });
        }
        return res;
      }, []);
      setDatasetsWithMultiAxis(updatedArray);
    };
    updateDatasetsArray("none");
  }, [selectedDatasetsArr]);

  useEffect(() => {
    setMultiAxisArray({ none: [], X: [], Y: [], size: [], color: [] });
    const tempArr: AxisAssignedArrays = { none: [], X: [], Y: [], size: [], color: [] };
    datasetsWithMultiAxis.forEach((d) => {
      tempArr[d.axis]?.push(
        <SelectedDatasetElement key={d.identifier} draggable onDragStart={(e: any) => onDragStart(e, d.identifier)}>
          {[d, removeDataset]}
        </SelectedDatasetElement>
      );
      /*  if ((tempArr["X"].length === 0 && d.axis === "X") || d.axis === "Y" || d.axis === "none") {
        tempArr[d.axis].push(
          <SelectedDatasetElement draggable onDragStart={(e: any) => onDragStart(e, d.id)}>
            {[d, removeDataset]}
          </SelectedDatasetElement>
        );
      } else {
        // X axis is assigned -> switch with new element
        if (tempArr["X"].length > 0 && d.axis === "X") {
         tempArr["none"].push(tempArr["X"][0]);
          tempArr["X"][0] = (
            <SelectedDatasetElement draggable onDragStart={(e: any) => onDragStart(e, d.id)}>
              {[d, removeDataset]}
            </SelectedDatasetElement>
          );
        }
      } */
    });
    if (tempArr["X"] !== undefined && tempArr["Y"] !== undefined && tempArr["color"] !== undefined && tempArr["size"] !== undefined) {
      const xDataset: string = tempArr["X"][0]?.props.children[0].identifier;
      const yDataset: string = tempArr["Y"][0]?.props.children[0].identifier;
      const colorDataset: string = tempArr["color"][0]?.props.children[0].identifier;
      const sizeDataset: string = tempArr["size"][0]?.props.children[0].identifier;
      assignToMultiAxis(xDataset, yDataset, colorDataset, sizeDataset);
      setMultiAxisArray(tempArr);
    }
  }, [datasetsWithMultiAxis]);

  useEffect(() => {
    const foundXIndex = datasetsWithMultiAxis.findIndex((d) => d.axis === "X");
    const foundYIndex = datasetsWithMultiAxis.findIndex((d) => d.axis === "Y");
    const foundColorIndex = datasetsWithMultiAxis.findIndex((d) => d.axis === "color");
    const foundSizeIndex = datasetsWithMultiAxis.findIndex((d) => d.axis === "size");
    if (foundXIndex !== -1) setFieldXClassName("");
    else setFieldXClassName("empty");
    if (foundYIndex !== -1) setFieldYClassName("");
    else setFieldYClassName("empty");
    if (foundColorIndex !== -1) setFieldColorClassName("");
    else setFieldColorClassName("empty");
    if (foundSizeIndex !== -1) setFieldSizeClassName("");
    else setFieldSizeClassName("empty");
  }, [datasetsWithMultiAxis]);

  const MultiAxisSelection = () => {
    
    return (
      <div className="dynamicRow">
        <div className="flexColumn" >
          <label htmlFor="dropbox">Selected multi datasets: </label>
          <div
            className="drop-box"
            id="dropbox"
            onDragOver={(e) => onDragOver(e)}
            onDrop={(e) => {
              onDropWithSwitch(e, "none");
            }}
          >
            {multiAxisArray.none}
          </div>
        </div>
        <div className="flexColumn">
          {enableXAxis && (
            <div className="" id="dropbox">
              <label htmlFor="dropboxX">X axis: </label>
              <div className="flexRow align-items-center justify-content-left ">
                <div
                  className={`drop-box ${fieldXClassName}`}
                  id="dropboxX"
                  onDragOver={(e) => onDragOver(e)}
                  onDrop={(e) => {
                    onDropWithSwitch(e, "X");
                  }}
                >
                  {multiAxisArray.X}
                </div>
              </div>
            </div>
          )}
          <div className="" id="dropbox">
            <label htmlFor="dropboxY">Y axis: </label>
            <div className="flexRow align-items-center justify-content-left">
              <div
                className={`drop-box ${fieldYClassName}`}
                id="dropboxY"
                onDragOver={(e) => onDragOver(e)}
                onDrop={(e) => {
                  onDropWithSwitch(e, "Y");
                }}
              >
                {multiAxisArray.Y}
              </div>
            </div>
          </div>
        </div>
        <div className="flexColumn">
          <div className="" id="dropbox">
            <label htmlFor="dropboxColor">Color axis: </label>
            <div className="flexRow align-items-center justify-content-left">
              <div
                className={`drop-box ${fieldColorClassName}`}
                id="dropboxColor"
                onDragOver={(e) => onDragOver(e)}
                onDrop={(e) => {
                  onDropWithSwitch(e, "color");
                }}
              >
                {multiAxisArray.color}
              </div>
            </div>
          </div>
          <div className="" id="dropbox">
            <label htmlFor="dropboxSize">Size axis: </label>
            <div className="flexRow align-items-center justify-content-left">
              <div
                className={`drop-box ${fieldSizeClassName}`}
                id="dropboxsize"
                onDragOver={(e) => onDragOver(e)}
                onDrop={(e) => {
                  onDropWithSwitch(e, "size");
                }}
              >
                {multiAxisArray.size}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="flexRow align-items-center justify-content-left margin">
        <MultiAxisSelection />
      </div>
    </>
  );
};

export default MultiDragArea;
